import axios from 'axios'
import {getCookie} from "./cookies"

export default (token = false) => {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `JWT ${token}`
        axios.defaults.headers.common['X-CSRFToken'] = getCookie('crmcsrftoken')
        //axios.defaults.headers.common['sessionid'] = getCookie('crmsessionid')
    } else {
        delete axios.defaults.headers.common['Authorization']
        delete axios.defaults.headers.common['X-CSRFToken']
        //delete axios.defaults.headers.common['sessionid']
    }
}